import { render } from "./UpdateWizard.vue?vue&type=template&id=adebe1f6"
import script from "./UpdateWizard.vue?vue&type=script&lang=js"
export * from "./UpdateWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__